import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Claim.BulkOwnershipUpdate.IRequest;
type Response = Api.Core.Claim.BulkOwnershipUpdate.IResponse;
type Headers = Api.Core.Claim.BulkOwnershipUpdate.IHeaders;
const url = '/api/Claims/Claim/BulkOwnershipUpdate';
export default async function claimBulkOwnershipUpdateApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
